export default {
  rentalTerms: {
    chapter: '5',
    component: 'helmi-section',
    props: {
      label: 'Vuokrausehdot',
    },
    children: {
      rent: {
        chapter: '5.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vuokran määrä',
          suffix: '€ / kk',
          type: 'number',
        },
        value: null,
      },

      rentDeposit: {
        chapter: '5.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vuokravakuus',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      rentalTime: {
        chapter: '5.3',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Vuokra-aika',
        },
        options: ['Toistaiseksi', 'Määräaikainen', 'Muu'],
        value: 'Toistaiseksi',
      },

      rentalTimeMoreInfo: {
        chapter: '5.3.1',
        component: 'helmi-text-field',
        condition: {
          item: 'rentalTime',
          type: '=',
          value: 'Muu',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Vuoka-aika lisätiedot',
          type: 'text',
        },
        value: null,
      },

      expenses: {
        chapter: '5.4',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Vuokralainen vastaa muista kustannuksista:',
        },
      },

      expenses_1: {
        chapter: '5.4.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Sähkö',
        },
        value: 'Ei',
      },

      expenses_2: {
        chapter: '5.4.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Lämmitys',
        },
        value: 'Ei',
      },

      expenses_3: {
        chapter: '5.4.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vesi',
        },
        value: 'Ei',
      },

      expenses_4: {
        chapter: '5.4.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Muu',
        },
        value: 'Ei',
      },

      otherExpense: {
        chapter: '5.4.4.1',
        component: 'helmi-text-field',
        condition: {
          item: 'expenses_4',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Muu kustannus',
          type: 'text',
        },
        value: null,
      },

      rentIncrease: {
        chapter: '5.5',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Vuokran korottaminen',
          type: 'text',
        },
        value: 'Indeksi',
      },

      smoking: {
        chapter: '5.6',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Tupakointi sallittu',
        },
        value: 'Ei',
      },

      pets: {
        chapter: '5.7',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Lemmikkieläimet sallittu',
        },
        value: 'Ei',
      },

      otherRentalTerms: {
        chapter: '5.8',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut vuokrausehdot',
          type: 'text',
        },
        value: null,
      },
    },
  },

  rent: {
    chapter: '6',
    component: 'helmi-section',
    props: {
      label: 'Kohteen vapautuminen / vuokralainen',
    },
    children: {

      releaseDate: {
        chapter: '6.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kohteen vapautuminen',
        },
        options: ['Heti vapaa', 'Vapautuu sopimuksen mukaan', 'Vapautuu pvm'],
        value: 'Heti vapaa',
      },

      releaseDate_1: {
        chapter: '6.1.1',
        component: 'helmi-date-picker',
        condition: {
          item: 'releaseDate',
          type: '=',
          value: 'Vapautuu pvm',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Vapautumispäivä',
          type: 'text',
        },
        value: null,
      },

      rented: {
        chapter: '6.2',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kohde on vuokrattu',
        },
        options: ['Kyllä', 'Ei'],
        value: 'Ei',
      },

      rentType_1: {
        chapter: '6.2.1',
        component: 'helmi-checkbox',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Kirjallinen sopimus',
        },
        value: 'Ei',
      },

      rentType_2: {
        chapter: '6.2.2',
        component: 'helmi-checkbox',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Suullinen sopimus',
        },
        value: 'Ei',
      },

      rentType_3: {
        chapter: '6.2.3',
        component: 'helmi-checkbox',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Määräaikainen sopimus',
        },
        value: 'Ei',
      },

      rentType_4: {
        chapter: '6.2.4',
        component: 'helmi-checkbox',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Toistaiseksi voimassaoleva sopimus',
        },
        value: 'Ei',
      },

      rentAmount: {
        chapter: '6.2.5',
        component: 'helmi-text-field',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vuokra',
          type: 'text',
        },
        value: null,
      },

      occupantName: {
        chapter: '6.2.6',
        component: 'helmi-text-field',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asukkaan nimi',
          type: 'text',
        },
        value: null,
      },

      occupantPhone: {
        chapter: '6.2.7',
        component: 'helmi-text-field',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asukkaan puhelinnumero',
          type: 'text',
        },
        value: null,
      },

      occupantEmail: {
        chapter: '6.2.8',
        component: 'helmi-text-field',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asukkaan sähköpostiosoite',
          type: 'text',
        },
        value: null,
      },

      additionalInfoLease: {
        chapter: '6.2.9',
        component: 'helmi-textarea',
        condition: {
          item: 'rented',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Lisätietoja vuokrasopimuksesta',
        },
        value: null,
      },
    },
  },

  periodOfValidity: {
    chapter: '7',
    component: 'helmi-section',
    props: {
      label: 'Toimeksiannon voimassaoloaika',
    },
    children: {
      typeOfAgreement: {
        chapter: '7.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiannon voimassaolo',
        },
        options: [
          'Määräaikainen',
          'Toistaiseksi voimassa oleva',
        ],
        value: 'Määräaikainen',
      },

      timeLimitedFrom: {
        chapter: '7.1.1',
        component: 'helmi-date-picker',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Määräaikainen',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Alkamispäivä (Määräaikainen)',
          type: 'text',
        },
        value: null,
      },

      untilFurtherNoticeFrom: {
        chapter: '7.1.3',
        component: 'helmi-date-picker',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Toistaiseksi voimassa oleva',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Alkamispäivä (Toistaiseksi)',
          type: 'text',
        },
        value: null,
      },

      timeLimitedTo: {
        chapter: '7.1.2',
        component: 'helmi-date-picker',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Määräaikainen',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Lopetuspäivä (Määräaikainen)',
          type: 'text',
        },
        value: null,
      },

      untilFurtherNoticePeriod: {
        chapter: '7.1.4',
        component: 'helmi-text-field',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Toistaiseksi voimassa oleva',
        },
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Jakson pituus (Toistaiseksi)',
          type: 'text',
        },
        value: null,
      },

      untilFurtherNoticeTitle: {
        chapter: '7.1.5',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        condition: {
          item: 'typeOfAgreement',
          type: '=',
          value: 'Toistaiseksi voimassa oleva',
        },
        props: {
          label: 'Toistaiseksi voimassa oleva toimeksianto on voimassa toistaiseksi valitusta ajankohdasta alkaen kohdassa 7.1.4 valitun pituisissa jaksoissa niin, että se voidaan kirjallisesti irtisanoa viimeistään kymmenen (10) päivää ennen seuraavan sopimuskauden alkamista. Toimeksiannon voimassaolo päättyy kuitenkin aina neljän kuukauden kuluttua voimassaolon alkamisesta, ellei sitä kirjallisesti jatketa välityslain edellyttämällä tavalla.',
        },
      },
    },
  },

  brokerageAndPayment: {
    chapter: '8',
    component: 'helmi-section',
    props: {
      label: 'Välityspalkkion suuruus ja suoritus',
    },
    children: {
      percentage: {
        chapter: '8.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Välityspalkkioprosentti sis. ALV',
          suffix: '%',
          type: 'number',
        },
        value: null,
      },

      fixedFee: {
        chapter: '8.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kiinteä palkkio sis. ALV',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      minimumFee: {
        chapter: '8.3',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vähimmäispalkkio sis. ALV',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      photography: {
        chapter: '8.4',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Valokuvaus sis. ALV',
          suffix: '€',
          type: 'number',
        },
        value: null,
      },

      marketing: {
        chapter: '8.5',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Markkinointikulut sis. ALV',
          type: 'number',
          suffix: '€',
        },
        value: null,
      },

      documents: {
        chapter: '8.6',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asiakirjakulut sis. ALV',
          type: 'number',
          suffix: '€',
        },
        value: null,
      },

      additionalFees: {
        chapter: '8.7',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Markkinointikustannuksista ja asiakirjojen hankkimisesta sovitun välityspalkkion lisäksi perittävät summat',
        },
      },

      otherExpenses: {
        chapter: '8.7.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut kustannukset',
          type: 'text',
        },
        value: null,
      },

      fallBackFees: {
        chapter: '8.8',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Jos toimeksiantaja ei ole velvollinen maksamaan välityspalkkiota, toimeksiantaja suorittaa välitysliikkeelle kuitenkin seuraavat korvaukset',
        },
      },

      marketingAndAqcuisitionFee: {
        chapter: '8.8.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Markkinointikustannukset ja asiakirjojen hankkimiskulu',
          type: 'text',
        },
        value: null,
      },
    },
  },

  additionalTerms: {
    chapter: '9',
    component: 'helmi-section',
    props: {
      label: 'Muut ehdot',
    },
    children: {
      responsibility_1: {
        chapter: '9.1',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          hint: '9.1 Välitysliike saa toimeksiantajan lukuun vastaanottaa vuokralaiselta vuokratarjouksen vakuudeksi varausmaksun.',
        },
      },
      responsibility_2: {
        chapter: '9.2',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          hint: '9.2 Välitysliike on oikeutettu välityspalkkioon, jos toimeksiantaja sopii vuokrauksesta toimeksiantosopimuksen voimassa ollessa. Jos vuokrauksesta sovitaan kuuden (6) kuukauden kuluessa tämän toimeksiannon päättymisestä, on välitysliikkeellä oikeus välityspalkkioon, mikäli välitysliikkeen tai sen palveluksessa olevien henkilöiden toimenpiteet ovat olennaisesti vaikuttaneet vuokrasopimuksen syntymiseen.',
        },
      },
      responsibility_3: {
        chapter: '9.3',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          hint: '9.3 Välitysliikkeellä on lisäksi oikeus palkkioon, mikäli toimeksiantaja ei hyväksy vuokratarjousta, joka vastaa tässä toimeksiannossa ja sen liitteenä olevassa selostusliitteessä tai myöhemmin erikseen hyväksyttyjä toimeksiannon ehtoja.',
        },
      },

      responsibility_4: {
        chapter: '9.4',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          hint: '9.4 Jos välitysliikkeen vastaanottama varausraha jää toimeksiantajan hyväksi, on välitysliike oikeutettu välityspalkkioon, jonka suuruus on puolet varausrahan määrästä, kuitenkin enintään toimeksiantosopimuksessa mainittu välityspalkkion määrä',
        },
      },

      responsibility_5: {
        chapter: '9.5',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          hint: '9.5 Palkkio erääntyy maksettavaksi vuokrasopimuksen allekirjoitustilaisuudessa, ellei muuta ole sovittu. Kuitenkin jos välitysliikkeen oikeus palkkioon perustuu näiden ehtojen 9.2)- ja 9.3)-kohtiin, tai oikeus korvaukseen perustuu välitysliikkeelle aiheutuneisiin kuluihin, palkkio tai kulukorvaus erääntyy maksettavaksi 14 pv kuluessa välitysliikkeen lähettämästä laskusta.',
        },
      },

      responsibility_6: {
        chapter: '9.6',
        classes: 'text-subtitle-2',
        hide: true,
        component: 'helmi-title',
        props: {
          hint: '9.6 Toimeksiantaja on tietoinen siitä, että tämän sopimuksen tietoja tallennetaan välitysliikkeen toimeksiantopäiväkirjaan Lain kiinteistönvälitysliikkeistä ja vuokrahuoneiston välitysliikkeistä (975/2000) määräysten mukaisesti.',
        },
      },

      inOfficeCommitment: {
        chapter: '9.7',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja on sitoutunut toimeksiantosopimuksen ehtoihin vasta välitysliikkeen toimitiloissa (ei kotimyyntitilanne).',
        },
        value: 'Ei',
      },

      outOfOfficeCommitment: {
        chapter: '9.8',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja on sitoutunut toimeksiantosopimuksen ehtoihin muualla kuin välitysliikkeen toimitiloissa. Tällöin kysymys on kotimyynnistä.',
        },
        value: 'Ei',
      },

      clientHasRecievedCancellationFormAndInstructions: {
        chapter: '9.9',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja kuittaa vastaanottaneensa erillisen peruuttamislomakkeen ja peruuttamisohjeen.',
        },
        value: 'Kyllä',
      },

      startBeforeCancellationTimeExpires: {
        chapter: '9.10',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja pyytää, että välitysliike aloittaa toimeksiannon suorittamisen ennen kuin peruuttamisaika on päättynyt.',
        },
        value: 'Kyllä',
      },

      asuntojenHintatiedotAcceptance: {
        chapter: '9.11',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Annan suostumukseni sille, että toteutuneen kaupan tiedot julkistetaan ympäristöministeriön asuntojen.hintatiedot.fi -palvelussa',
        },
        value: 'Ei',
      },

      otherTerms: {
        chapter: '9.12',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut ehdot',
          type: 'text',
        },
        value: null,
      },
    },
  },

  privacy: {
    chapter: '10',
    component: 'helmi-section',
    props: {
      label: 'Tietosuoja',
    },
    children: {
      privacyClause: {
        chapter: '10.1',
        component: 'helmi-title',
        hide: true,
        container: {
          cols: 12,
        },
        props: {
          hint: 'Asiakas on tietoinen siitä, että tämän lomakkeen allekirjoittajan tietoja tallennetaan välitysliikkeen toimeksiantopäiväkirjaan ja asiakasrekisteriin kiinteistönvälitysliikkeistä ja vuokrahuoneiston välitysliikkeistä annetun lain sekä rahanpesun ja terrorismin rahoittamisen estämisestä annetun lain määräysten mukaisesti. Lisäksi henkilötietoja käytetään tietosuojaselosteessa tarkemmin kuvatun mukaisesti markkinointitarkoituksia ja liiketoiminnan kehittämistä varten',
        },
      },

      privacyPolicyAvailability: {
        chapter: '10.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Asiakasta on ohjattu tutustumaan etukäteen tietosuojaselosteeseen.',
        },
        value: 'Kyllä',
      },

      dataHandlingAgreement: {
        chapter: '10.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kaupan tietoja luovutetaan Kiinteistönvälitysalan Keskusliitto (KVKL) ry:lle, jossa tiedot tallennetaan KVKL:n hintaseurantapalveluun (HSP), jonka tietosuojaseloste on saatavilla osoitteesta www.hintaseurantapalvelu.fi/tietosuoja. Lisäksi pyydämme suostumustanne alla selostettuja tarkoituksia varten. Annatte suostumuksenne lisäämällä rastin ruutuun. Teillä on oikeus peruuttaa suostumus milloin tahansa ilmoittamalla peruuttamisesta kirjallisesti tai sähköpostitse välitysliikkeelle.',
        },
        value: 'Kyllä',
      },

      marketingAgreement: {
        chapter: '10.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Annan suostumukseni siihen, että välitysliike saa lähettää minulle sähköistä suoramarkkinointia (esim. tekstiviesti, sähköposti).',
        },
        value: 'Kyllä',
      },

      identificationInformationSharingAgreement: {
        chapter: '10.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Annan suostumukseni siihen, että välitysliike lähettää minulle, kaupan toiselle osapuolelle, isännöitsijälle, asiaan osalliselle pankille ja/tai viranomaiselle sähköpostitse henkilötunnukseni sisältäviä asiakirjoja. Henkilötunnuksen jakaminen näiden tahojen kanssa on välttämätöntä tunnistamisen varmistamiseksi.',
        },
        value: 'Kyllä',
      },

      unencryptedEmailAwareness: {
        chapter: '10.5',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Olen tietoinen siitä, että sähköpostia ei lähetetä suojatussa yhteydessä eikä salattuna.',
        },
        value: 'Kyllä',
      },
    },
  },

  politicalInfluence: {
    chapter: '11',
    component: 'helmi-section',
    props: {
      label: 'Poliittinen vaikutusvalta',
    },
    children: {
      PEPStatus: {
        chapter: '11.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Oletko tai oletko ollut viimeisen vuoden aikana poliittisesti vaikutusvaltainen henkilö (PEP) tai sellaisen henkilön perheenjäsen tai läheinen yhtiökumppani?',
          dense: false,
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },
      PEPAdditionalInfo: {
        chapter: '11.1.1',
        component: 'helmi-textarea',
        condition: {
          item: 'PEPStatus',
          type: '=',
          value: 'Kyllä',
        },
        container: {
          cols: 12,
        },
        props: {
          label: 'Lisätietoja',
        },
        value: null,
      },
    },
  },
};
